import { useEffect, useMemo, useState } from "react";
import Spinner from "../../Organization/components/Spinner";
import { Avatar, Button, message, Tag } from "antd";
import { avatarBg, getColorByLetter } from "../../../common/helpers";
import { STATUS_APPROVED, STATUS_NEW, STATUS_PARTNER_INTEREST_ACCEPTED, STATUS_PARTNER_INTEREST_EXPRESSED, STATUS_PARTNER_INTEREST_SKIPPED, STATUS_RECOMMENDED, USER_TYPE_ADMIN, USER_TYPE_ORGANIZATION, } from "../../../constants/constants";
import LinkIcon from "../../../components/icons/LinkIcon";
import { getPartnerByID } from "../../../API/endpoints/Partner";
import PartnerInfo from "../../Partner/PartnerInfo";
import DetailltemMore from "../../Organization/components/DetailltemMore";
import DocIcon from "../../../components/icons/DocIcon";
import ChinaFlag from "../../../components/icons/flags/ChinaFlag";
import HongKongFlag from "../../../components/icons/flags/HongKongFlag";
import IndiaFlag from "../../../components/icons/flags/IndiaFlag";
import IndonesiaFlag from "../../../components/icons/flags/IndonesiaFlag";
import JapanFlag from "../../../components/icons/flags/JapanFlag";
import MalasiaFlag from "../../../components/icons/flags/MalasiaFlag";
import PhlippinesFlag from "../../../components/icons/flags/PhlippinesFlag";
import SingaporeFlag from "../../../components/icons/flags/SingaporeFlag";
import SKoreaFlag from "../../../components/icons/flags/SKoreaFlag";
import TaiwanFlag from "../../../components/icons/flags/TaiwanFlag";
import ThailandFlag from "../../../components/icons/flags/ThailandFlag";
import VietnamFlag from "../../../components/icons/flags/VietnamFlag";
import AustraliaFlag from "../../../components/icons/flags/AustraliaFlag";
import ConfirmModal from "./ConfirmModal";
import { createBrandRequestPartner, updateBrandRequestPartner } from "../../../API/endpoints/Discovery";
import { useParams } from "react-router-dom";

interface Props {
    id: any;
    userType: string;
    data: any;
    reloadPartners: () => void;
    updateStatus: (status: string) => void;
}
const PartnerProfile = (props: Props) => {
    const { id, userType, data } = props;

    const params = useParams();

    const [details, setDetails] = useState<any>({});
    const [loading, setLoading] = useState(false);

    const [messageApi, contextHolder] = message.useMessage();

    const [confirmModalData, setConfirmModalData] = useState<any>({
        type: "",
        title: "",
        message: "",
        okText: ""
    })

    useEffect(() => {
        getPartnerByID(id).then((res: any) => {
            setDetails(res?.data)
        }).catch((err) => {
            console.log("err", err);

        })
    }, [id]);


    const confirmRecommend = () => {
        setConfirmModalData({
            type: STATUS_RECOMMENDED,
            message: `Are you sure you want to recommend ${details?.name} to the brand for this request?`,
            okText: "Recommend",
            title: "Recommend Partner"
        })
    }

    const confirmAccept = () => {
        setConfirmModalData({
            type: STATUS_PARTNER_INTEREST_ACCEPTED,
            message: `Are you sure you want to accept this request?`,
            okText: "Yes, Accept",
            title: "Accept Request"
        })
    }


    const onCancelConfirm = () => {
        setConfirmModalData({
            type: "",
            title: "",
            message: "",
            okText: ""
        })
    }

    const onOkConfirm = () => {
        const req = confirmModalData?.type === STATUS_PARTNER_INTEREST_ACCEPTED ? {
            status: confirmModalData?.type
        } : {
            recommended: true
        }
        if (data?.discovery_request_id) {
            updateBrandRequestPartner(data?.id, req).then((res: any) => {
                messageApi.success(`${confirmModalData?.type === STATUS_PARTNER_INTEREST_ACCEPTED ? "Interest accepted" : "Recommended partner"} successfully`)
                onCancelConfirm();
                confirmModalData?.type === STATUS_PARTNER_INTEREST_ACCEPTED ? props.updateStatus(confirmModalData?.type) : props.reloadPartners()
            }).catch((err) => {
                console.error('err', err);
                messageApi.error(`Failed to ${confirmModalData?.type === STATUS_PARTNER_INTEREST_ACCEPTED ? "accept interest" : "recommend partner"}. Please try again!`)
            })
        } else {
            const req = {
                status: STATUS_RECOMMENDED,
                discovery_request_id: params?.id,
                partner_id: id,
                recommended: true
            }

            createBrandRequestPartner(req).then((res: any) => {
                messageApi.success(`Recommended partner successfully`)
                onCancelConfirm();
                props.reloadPartners()
            }).catch((err) => {
                console.error('err', err);
                messageApi.error(`Failed to recommend partner. Please try again!`)
            })
        }

    }

    const openLink = (link: string) => {
        if (link) {
            const fullUrl = link.startsWith("http") ? link : `https://${link}`;
            window.open(fullUrl, "_blank", "noopener,noreferrer");
        }
    }

    const docs = useMemo(() => {
        return [
            {
                id: "client_portfolio",
                title: "Client Portfolio",
                url: details?.client_portfolio
            },
            {
                id: "company_overview",
                title: "Company Overview",
                url: details?.company_overview
            },
            {
                id: "draft_agreements",
                title: "Draft Agreements",
                url: details?.draft_agreements
            },
        ]
    }, [details])


    const marketsList = useMemo(() => {
        return <PartnerInfo data={details} noScroll={true} />
    }, [details])

    const docsList = useMemo(() => {
        return docs?.map((item: any, index: number) => {
            return (
                <div key={index} onClick={() => openLink(item?.url)} className="flex gap-x-[6px] cursor-pointer">
                    <DocIcon />
                    <p className="m-0 text-[12px] text-gray-700 hover:text-gray-800 transition-all duration-200">{item.title}</p>
                </div>
            )
        })
    }, [docs]);


    const flagIcon = (country: string) => {
        switch (country) {
            case "China":
                return <ChinaFlag />
            case "Hong Kong":
                return <HongKongFlag />
            case "India":
                return <IndiaFlag />
            case "Indonesia":
                return <IndonesiaFlag />
            case "Japan":
                return <JapanFlag />
            case "Malaysia":
                return <MalasiaFlag />
            case "Philippines":
                return <PhlippinesFlag />
            case "Singapore":
                return <SingaporeFlag />
            case "South Korea":
                return <SKoreaFlag />
            case "Taiwan":
                return <TaiwanFlag />
            case "Thailand":
                return <ThailandFlag />
            case "Vietnam":
                return <VietnamFlag />
            case "Australia":
                return <AustraliaFlag />
            case "Thailand":
                return <ThailandFlag />

            default:
                return <></>
        }
    }


    return (
        <div className="h-[calc(100vh-120px)] overflow-auto px-[16px] overflow-scroll-bar">
            {contextHolder}
            <div className='bg-white rounded-[8px] p-[16px] w-full grid grid-cols-8 mb-[16px]'>
                {loading ? (
                    <div className='w-full col-span-7 h-[90px]'>
                        <Spinner />
                    </div>

                ) : (
                    <>
                        <div className='col-span-3 flex gap-x-[12px] border-r border-[#E4E7EC] pr-[40px]'>
                            <Avatar shape="square" size={'large'} style={details?.name ? getColorByLetter(details?.name?.charAt(0)) : undefined}>{details?.name?.charAt(0)}</Avatar>
                            <div>
                                <div className="flex items-center gap-x-[8px]">
                                    <p className='m-0 text-[#1D2939] text-[14px] font-[500]'>{details?.name}</p>
                                    {data?.recommended || data?.status === STATUS_PARTNER_INTEREST_ACCEPTED ? (
                                        <Tag bordered={false} color='success' className="capitalize !rounded-[24px] text-[10px] font-[500]">{data?.status === STATUS_PARTNER_INTEREST_ACCEPTED ? "Interest Accepted" : "Recommended"}</Tag>
                                    ) : (
                                        <></>
                                    )}
                                </div>
                                <div className="flex items-center gap-x-[8px]">
                                    {flagIcon(details?.region?.name)}
                                    <p className='mt-[4px] text-[#475467] text-[12px] mb-[4px]'>{details?.region?.name}</p>
                                </div>
                                {details?.website ? (
                                    <div className='flex gap-x-[4px] items-center cursor-pointer' onClick={() => openLink(details?.website)}>
                                        <LinkIcon />
                                        <p className='max-w-[170px] truncate text-[12px] m-0 text-[#175CD3]'>{details?.website}</p>
                                    </div>
                                ) : (
                                    <></>
                                )}

                            </div>
                        </div>
                        <div className="col-span-3 pr-[40px]  ml-[40px]">
                            <p className="text-[12px] font-[500]">Documents:</p>
                            {docsList}
                        </div>
                        <div className="col-span-2 ml-[40px] self-center text-end">
                            {userType === USER_TYPE_ADMIN && !data?.recommended && data?.discovery_request_id ? (
                                <Button type="primary" onClick={() => confirmRecommend()}>Recommend</Button>
                            ) : (
                                <></>
                            )}

                            {userType === USER_TYPE_ORGANIZATION && data?.status !== STATUS_PARTNER_INTEREST_ACCEPTED ? (
                                <Button type="primary" onClick={() => confirmAccept()}>Accept</Button>
                            ) : (
                                <></>
                            )}



                        </div>
                    </>

                )}

            </div>
            {marketsList}

            <ConfirmModal
                open={Boolean(confirmModalData.type)}
                content={confirmModalData.message}
                onCancel={onCancelConfirm}
                onOk={onOkConfirm}
                okText={confirmModalData.okText}
                title={confirmModalData.title}
            />
        </div>
    )
}

export default PartnerProfile